import React from "react";
import "../styles/PrivacyPolicyPage.css";

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy">
      <section className="privacy-hero">
        <h1>Privacy Policy</h1>
        <p>Your privacy matters to us at SAC MTB 🚴‍♂️</p>
      </section>

      <section className="privacy-content">
        <h2>1. Introduction</h2>
        <p>
          Welcome to <strong>SAC MTB</strong>. We respect your privacy and are committed 
          to protecting your personal data. This policy outlines how we collect, 
          use, and safeguard your information when you visit our website or make a purchase.
        </p>

        <h2>2. Information We Collect</h2>
        <ul>
          <li>Personal details such as your name, email, phone number, and address.</li>
          <li>Payment and transaction details when you place an order.</li>
          <li>Technical data including IP address, browser type, and device information.</li>
          <li>Feedback, messages, or other information you provide voluntarily.</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <p>We use the information collected for purposes such as:</p>
        <ul>
          <li>Processing and fulfilling your orders</li>
          <li>Providing customer support</li>
          <li>Improving our website and product offerings</li>
          <li>Sending promotional offers and updates (only if you opt-in)</li>
        </ul>

        <h2>4. Data Protection</h2>
        <p>
          Your data is securely stored and transmitted using SSL encryption. 
          We never sell, rent, or share your personal information with third parties, 
          except when required by law or to complete your order.
        </p>

        <h2>5. Cookies</h2>
        <p>
          We use cookies to enhance your browsing experience and analyze website traffic. 
          You can disable cookies anytime from your browser settings.
        </p>

        <h2>6. Third-Party Services</h2>
        <p>
          We may use trusted third-party partners for analytics, payments, or delivery. 
          Each service provider follows strict confidentiality and data protection standards.
        </p>

        <h2>7. Your Rights</h2>
        <p>
          You have the right to access, correct, or delete your personal information. 
          To make a request, contact us at{" "}
          <a href="mailto:support@sacmtb.com">support@sacmtb.com</a>.
        </p>

        <h2>8. Updates to This Policy</h2>
        <p>
          We may update this Privacy Policy occasionally. Any changes will be reflected 
          on this page with the updated date at the bottom.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          For any questions regarding our Privacy Policy, reach us at: <br />
          <strong>Email:</strong> support@sacmtb.com <br />
          <strong>WhatsApp:</strong> +91 6396353776
        </p>

        <p className="last-updated">
          <em>Last Updated: November 2025</em>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
